import Dashboard from "../Pages/Dashboard/Dashboard";
import Client from "../Pages/Client/Client";
import AddNewClient from "../Pages/Client/AddNewClient";
import EditClient from "../Pages/Client/EditClient";
import UserReport from "../Pages/UserReport/UserReport";
import ProductList from "../Pages/ProductList/ProductList";
import AddNewProductList from "../Pages/ProductList/AddNewProductList";

const unProtectedRoutes = [
  {
    path: "/",
    component: <>Login</>,
  },
  {
    path: "/login",
    component: <>Login</>,
  },
];

const protectedRoutes = [
  {
    path: "dashboard",
    title: "Dashboard",
    key: "dashboard",
    component: <Dashboard />,
  },
  {
    path: "client",
    title: "client",
    key: "client",
    component: <Client />,
  },
  {
    path: "client/addclient",
    title: "Addclient",
    key: "addclient",
    component: <AddNewClient />,
  },
  {
    path: "client/editclient",
    title: "editclient",
    key: "editclient",
    component: <EditClient />,
  },
  {
    path: "report",
    title: "report",
    key: "report",
    component: <UserReport />,
  },
  {
    path: "productlist",
    title: "productlist",
    key: "productlist",
    component: <ProductList />,
  },
  {
    path: "productlist/addproductlist",
    title: "Addproductlist",
    key: "addproductlist",
    component: <AddNewProductList />,
  },
  {
    path: "productlist/editproductlist",
    title: "Editproductlist",
    key: "editproductlist",
    component: <AddNewProductList />,
  },
];

export const routesData = { unProtectedRoutes, protectedRoutes };
